<template>
<div class='infos-card'>
  <export-dialog ref='export-dialog' :loading.sync="exportLoading" />
  <record-dialog ref='record-dialog' />

  <div class='project-name'>
    <span>{{project.name}}</span>
  </div>

  <div class='qrcode-wrapper'>
    <img class='qrcode' :src="'//qrcode.ppj.io/' + project.viewer_url" />
    <p class='hint'>{{$t('qrcode.project')}}</p>
    <div class='link-info'>
      <el-input :placeholder="$t('placeholder.project.viewer_url')" v-model='project.viewer_url' class='link-input' readonly>
        <div class='append-buttons' slot='append'>
          <a class='copy el-button' v-clipboard:copy="project.viewer_url" v-clipboard:success="onCopy">
              {{$t('common.buttons.copy')}}
          </a>
          <a class='preview el-button' :href="project.viewer_url" target='_blank'>
              {{$t('common.buttons.preview')}}
          </a>
        </div>
      </el-input>
    </div>
  </div>

  <div class='buttons-group'>
    <!--<el-button :plain="true" type='info' style="margin-right: 10px;" @click="$refs['record-dialog'].open()" v-if="!readonly">
      {{$t('common.buttons.record')}}
    </el-button>
    -->
    <el-dropdown menu-align="start" @command='exportDropdownCommand' v-if="!tbcMode && !readonly">
      <el-button :plain="true" type='info' class='export-downdir-btn'>
        <i class='ppj-icon-down-dir'></i>
      </el-button>
      <el-button :plain="true" :loading="exportLoading" type='info' class='export-btn' @click="openExportDialog('html5')">
        {{exportLoading ? '加载中' : $t('common.buttons.export.html5')}}
      </el-button>
      <el-dropdown-menu class='export-dropdown-menu' slot="dropdown">
        <el-dropdown-item class='export-dropdown-item' command='scorm'>
          {{$t(`common.buttons.export.scorm`)}}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</div>
</template>

<script>
import ExportDialog from './export.dialog'
//import RecordDialog from './record.dialog'

export default {
  data() {
    return {
      exportLoading: false
    }
  },
  components: {
    'export-dialog': ExportDialog,
    //'record-dialog': RecordDialog
  },
  computed: {
    project() {
      return this.$store.state.project.items[this.$route.params.id]
    },
    readonly() {
      return this.project.permissions.readonly
    }
  },
  methods: {
    onCopy: function(e) {
      this.$message({
        message: this.$t('common.infos.copy'),
        type: 'success'
      })
    },
    openExportDialog(type) {
      this.$refs['export-dialog'].open(type)
    },
    exportDropdownCommand: function(command) {
      this.openExportDialog(command)
    }
  }
}
</script>

<style lang='scss' scoped>
$show-wrapper-width: 300px;

.infos-card {
    float: left;
    width: $show-wrapper-width;

    $qrcode-wrapper-width: $show-wrapper-width;

    > div {
        margin-bottom: $padding-base;
        &:last-of-type {
            margin-bottom: 0;
        }
    }

    .project-name {
        color: $font-color-strong;
        font-weight: bolder;
        margin-left: 0.05 * $show-wrapper-width;
        width: 0.9 * $show-wrapper-width;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-bottom: 25px;
    }

    .qrcode-wrapper {
        width: $qrcode-wrapper-width;
        border: $border-base;
        background-color: #FDFDFD;
        padding-top: 0.15 * $qrcode-wrapper-width;
        padding-bottom: $padding-base;

        .qrcode {
            width: 0.6 * $qrcode-wrapper-width;
            height: 0.6 * $qrcode-wrapper-width;
        }

        .link-info {
            width: 0.9 * $qrcode-wrapper-width;
            margin: 0 auto;
            border-top: $border-base;
            padding: $padding-base 0 0;
            font-size: $font-size-small;
            overflow: hidden;
            text-align: left;
            line-height: 1.2;

            .link-input {
                font-size: $font-size-small;
            }

            $inner-button-width: 32px;
            .append-buttons {
                display: table;
                margin: 0 -10px;
                .el-button {
                    display: table-cell;
                    border: none;
                    margin: 0;
                    padding: 0 0.6em;
                    height: 30px;
                    line-height: 30px;
                    color: $font-color-base;
                    background-color: $color-white-base;
                    &.copy {
                        border-right: $border-base;
                    }
                }
            }
        }
    }

    .buttons-group {
        width: 100%;
        text-align: left;
        .el-button {
            font-size: $font-size-small;
        }

        .export-btn {
            margin-left: 0;
            text-align: left;
            border-right: 0;
            border-radius: 1px 0 0 1px;
            width: 80px;
            &:hover {
                color: darken($color-info, 20%);
                border-color: $color-info;
            }
        }
        .export-downdir-btn {
            width: 22px;
            float: right;
            border-radius: 0 1px 1px 0;
            border-left-style: dotted;
            padding-left: 0;
            padding-right: 0;
            &:hover {
                color: darken($color-info, 20%);
                border-color: darken($color-info, 20%);
            }
        }

        .loading {
            display: inline-block;
            position: absolute;
            line-height: 28px;
            margin-left: 10px;
        }
    }
}

.export-dropdown-menu {
    box-sizing: border-box;
    min-width: 0;
    font-size: $font-size-small;
    box-shadow: none;
    margin: 2px 0 0;
    border: $border-base;
    border-color: lighten($color-info, 20%);
    padding: 0;

    .export-dropdown-item {
        padding: 0.6em 1.5em;
        line-height: 1;
        color: $color-info;
        &:hover {
            color: darken($color-info, 20%) !important;
            background: $color-info-bg !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?ef857a52